import Mockman from "mockman-js";

function MockAPI() {
  return (
    <div className="MockAPI">
      <Mockman colorScheme="standard" />
    </div>
  );
}

export default MockAPI;